import {remCalc} from '_themeUtils'

const headline = {
    Headline: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                gridColumn: '1 / -1',
                alignItems: {base: 'flex-start', md: 'center'},
                justifyContent: 'center',
                textAlign: {base: 'left', md: 'center'},
                gap: 'spacing.5',
                pt: 0,
            },
            withBanner: {
                mt: {base: 'spacing.none', md: 'spacing.10'},
            },
            title: {
                textStyle: {base: 'displayXs', md: 'displayLg'},
                letterSpacing: remCalc(1.5),
                py: {base: 'spacing.3', md: 'spacing.none'},
            },
            skeletonTitle: {
                w: {base: '100%', md: '30%'},
                h: remCalc(41),
            },
            description: {
                textStyle: 'paragraphSm',
                textAlign: 'center',
                fontWeight: 400,
                letterSpacing: remCalc(1.5),
                maxW: remCalc(638),
                mt: {base: 0, md: 'spacing.8'},
                mb: 'spacing.8',
                px: 'spacing.6',
            },
            skeletonDescription: {
                w: {base: '100%', md: '50%'},
            },
        }),
        variants: {
            wishlist: {
                wrapper: {
                    alignItems: 'center',
                    pt: {base: 'spacing.6', md: 0},
                },
                title: {
                    textStyle: 'displayLg',
                },
                description: {
                    textStyle: 'paragraphLg',
                    mt: 0,
                },
                skeletonDescription: {
                    maxW: remCalc(180),
                },
            },
        },
    },
}

export default headline
